"use client";

import React from "react";
import { ZoomIn } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
const portfolioItems = [{
  id: 1,
  title: "Precision SLA Prototype",
  category: "3D Printing",
  description: "High-resolution architectural model featuring intricate internal geometries. Material: Tough Resin | Process: SLA Printing",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591244/img/portfolio_strategy_restructuring.png"
}, {
  id: 2,
  title: "Vector Etched Walnut",
  category: "Laser Engraving",
  description: "Deep-grain engraving on sustainably sourced solid walnut for premium branding. Material: Walnut | Process: CO2 Laser",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591244/img/portfolio_financial_analysis.png"
}, {
  id: 3,
  title: "Diffused Acrylic Light",
  category: "Light Design",
  description: "Custom geometric light fixture with integrated smart LEDs and frosted finishes. Material: Acrylic | Process: CNC Fabrication",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591244/img/portfolio_supply_chain.png"
}, {
  id: 4,
  title: "Carbon Fiber Assembly",
  category: "3D Printing",
  description: "Industrial-grade mechanical components designed for high-stress aerospace testing. Material: CF-Nylon | Process: FDM Printing",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591244/img/portfolio_leadership_training.png"
}, {
  id: 5,
  title: "Fiber Marked Panels",
  category: "Laser Engraving",
  description: "Permanent high-contrast industrial marking on anodized aluminum equipment panels. Material: Aluminum | Process: Fiber Laser",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591244/img/portfolio_digital_transformation.png"
}, {
  id: 6,
  title: "Layered Luminance",
  category: "Light Design",
  description: "Multi-dimensional signage featuring edge-lit acrylic layers and programmed RGB. Material: Cast Acrylic | Process: Multi-pass Laser",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591244/img/portfolio_risk_mitigation.png"
}];
export default function OurVisualLegacy() {
  return <section data-section-id="152070" id="the-fabrication-gallery" className="py-24 bg-background text-foreground dark">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col items-center text-center mb-16 space-y-4">
          <Badge variant="outline" className="uppercase tracking-widest text-primary border-primary/30 bg-primary/10 rounded-none font-mono text-xs">
            Portfolio
          </Badge>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold tracking-tighter font-sans text-foreground">
            The Fabrication Gallery
          </h2>
          <p className="max-w-[700px] text-muted-foreground md:text-lg/relaxed font-sans">
            A showcase of industrial precision and creative engineering, from rapid prototypes to bespoke lighting installations.
          </p>
        </div>

        <div className="columns-1 sm:columns-2 lg:columns-3 gap-6 space-y-6">
          {portfolioItems.map((item, i) => <div key={item.id} data-index={i} className="break-inside-avoid">
              <Dialog>
                <DialogTrigger asChild>
                  <div className="group relative cursor-pointer overflow-hidden rounded-none border border-border/20 bg-card shadow-none transition-all duration-300 hover:border-primary/50" tabIndex={0} role="button" aria-label={`View details for ${item.title}`}>
                    <div className="relative aspect-auto w-full overflow-hidden bg-muted">
                      <img src={item.image} alt={item.title} className="w-full h-auto object-cover grayscale brightness-75 transition-all duration-500 ease-in-out group-hover:scale-100 group-hover:grayscale-0 group-hover:brightness-100" loading="lazy" />
                      
                      {}
                      <div className="absolute top-4 left-4 z-10">
                        <Badge variant="secondary" className="bg-background/90 backdrop-blur-none border-border/50 text-foreground rounded-none font-mono text-[10px] uppercase tracking-wider">
                          {item.category}
                        </Badge>
                      </div>

                      {}
                      <div className="absolute inset-0 z-20 flex items-center justify-center bg-background/40 opacity-0 backdrop-blur-none transition-opacity duration-300 group-hover:opacity-100">
                        <div className="rounded-none bg-primary p-3 shadow-none transform translate-y-0 opacity-0 transition-all duration-300 group-hover:opacity-100">
                          <ZoomIn className="size-6 text-primary-foreground" />
                        </div>
                      </div>
                    </div>
                  </div>
                </DialogTrigger>
                
                <DialogContent className="max-w-4xl bg-card border-border shadow-2xl rounded-none overflow-hidden p-0 gap-0">
                  <div className="grid md:grid-cols-2 h-full max-h-[85vh]">
                    <div className="relative h-64 md:h-full w-full bg-muted">
                      <img src={item.image} alt={item.title} className="absolute inset-0 w-full h-full object-cover" />
                    </div>
                    <div className="flex flex-col justify-center p-8 md:p-12 bg-card">
                      <DialogHeader className="text-left space-y-4">
                        <Badge className="w-fit bg-secondary text-secondary-foreground rounded-none border-none font-mono text-xs uppercase tracking-widest">
                          {item.category}
                        </Badge>
                        <DialogTitle className="text-2xl md:text-3xl font-sans font-bold tracking-tight leading-tight uppercase">
                          {item.title}
                        </DialogTitle>
                        <DialogDescription className="text-base md:text-lg text-muted-foreground leading-relaxed pt-4 border-t border-border/20 font-sans">
                          {item.description}
                        </DialogDescription>
                      </DialogHeader>
                    </div>
                  </div>
                </DialogContent>
              </Dialog>
            </div>)}
        </div>
      </div>
    </section>;
}